import type { MenuItem } from '@/types';

/**
 * iOS docs menu
 */
export const iosDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/ios/overview' },
  {
    label: 'Express API',
    path: '/sdk_ref/ios/express',
    openNested: true,
    submenu: [
      { label: 'Channel', path: '/sdk_ref/ios/express-channel' },
      { label: 'Room', path: '/sdk_ref/ios/express-room' },
      { label: 'PCast™ Express', path: '/sdk_ref/ios/express-pcast' },
    ],
  },
  {
    label: 'Low-Level API',
    path: '/sdk_ref/ios/low-level',
    openNested: true,
    submenu: [
      { label: 'PCast™', path: '/sdk_ref/ios/pcast' },
      { label: 'Room', path: '/sdk_ref/ios/room' },
      { label: 'Chat', path: '/sdk_ref/ios/chat' },
    ],
  },

  { label: 'Ancillary Modules', path: '/sdk_ref/ios/ios-ancillary' },
  { label: 'Examples', path: '/sdk_ref/ios/examples' },
  { label: 'Release Notes', path: '/sdk_ref/ios/release-notes' },
  { label: 'iOS SDK Beta', path: '/sdk_ref/ios/ios-beta', 
  openNested: true,
  submenu: [
    { label: 'Version Comparison', path: '/sdk_ref/ios/prior-versions-ios' },
    { label: 'Channel Express - Beta', path: '/sdk_ref/ios/express-channel-beta' },
    { label: 'Room Express - Beta', path: '/sdk_ref/ios/express-room-beta' },
    { label: 'PCast™ Express - Beta', path: '/sdk_ref/ios/express-pcast-beta' },
    { label: 'Low-Level PCast™ - Beta', path: '/sdk_ref/ios/pcast-beta' },
    { label: 'Low-Level Room - Beta', path: '/sdk_ref/ios/room-beta' },
    { label: 'Low-Level Chat - Beta', path: '/sdk_ref/ios/chat-beta' },
  ],
},
];
